import {useSelector} from "react-redux";
import {currentUserSelector} from "../features/Auth/authSlice";

export default function useCurrentUser() {
	return useSelector(currentUserSelector);
}